// @flow
import React, {PureComponent} from 'react';
import {View, StyleSheet} from 'react-native';
import {Link, Text} from 'trpc-react-native-ui';
import {WebView} from 'react-native-webview';
import I18n from '../../../../lib/i18n';
import {Icon, Modal} from '../../../../components/common';
import theme from '../../../../theme-config';

const statusMapping = {
  inPreparation: I18n.t('Dashboard.Orders.orderStatus.inPreparation'),
  shipped: I18n.t('Dashboard.Orders.orderStatus.shipped'),
  delivered: I18n.t('Dashboard.Orders.orderStatus.delivered'),
  cancelled: I18n.t('Dashboard.Orders.orderStatus.cancelled'),
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      justifyContent: 'flex-start',
      flexDirection: 'row',
      marginTop: 15,
    },
    icon: {
      color: theme.signUpIconColor,
      fontSize: 20,
      marginLeft: 5,
    },
    textContainer: {
      marginLeft: 16,
      flex: 1,
      flexWrap: 'wrap',
    },
    subText: {
      fontWeight: '100',
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'baseline',
    },
    title: {
      marginRight: 15,
      fontWeight: '400',
    },
    link: {
      fontSize: 13,
    },
  });
export default class DeliveryStatus extends PureComponent<Props, State> {
  state = {
    isTrackDeliveryModalOpened: false,
  };
  getSubText = (status: 'inPreparation' | 'shipped' | 'cancelled') => {
    if (status === 'shipped') {
      const {trackingId} = this.props;
      if (!!trackingId) {
        return `${I18n.t('Dashboard.Orders.trackingId')} ${trackingId}`;
      }
      return `${I18n.t('Dashboard.Orders.unknownTrackingId')}`;
    }

    return '';
  };

  openTrackDeliveryModal = () =>
    this.setState({isTrackDeliveryModalOpened: true});
  closeTrackDeliveryModal = () =>
    this.setState({isTrackDeliveryModalOpened: false});

  render() {
    const styles = getStyles();
    return (
      <View style={styles.container}>
        <Icon style={styles.icon} name={'clock'} />
        <View style={styles.textContainer}>
          <View style={styles.titleContainer}>
            <Text style={styles.title}>{statusMapping[this.props.status]}</Text>
            {this.props.trackingLink && (
              <Link
                style={styles.link}
                onPress={this.openTrackDeliveryModal}
                text={I18n.t('Dashboard.Orders.checkProgression')}
              />
            )}
          </View>
          <Text style={styles.subText}>
            {this.getSubText(this.props.status)}
          </Text>
        </View>
        {this.props.trackingLink && (
          <Modal
            visible={this.state.isTrackDeliveryModalOpened}
            requestClose={this.closeTrackDeliveryModal}
            fullScreen>
            <WebView
              source={{uri: this.props.trackingLink}}
              originWhitelist={['https://']}
            />
          </Modal>
        )}
      </View>
    );
  }
}

type Props = {
  status: 'inPreparation' | 'shipped' | 'cancelled',
  trackingId?: string,
  trackingLink?: string,
};

type State = {
  isTrackDeliveryModalOpened: boolean,
};
